import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cantines: [],
  singleCantines:{},
  productionTypes: [],
  isLoading: false,
  error: null,
};

const cantineSlice = createSlice({
  name: "cantine",
  initialState,
  reducers: {
    setCantines: (state, action) => {
      state.cantines = action.payload;
    },
    addCantine: (state, action) => {
      state.cantines.push(action.payload);
    },
    addCantineId: (state, action) => {
      console.log(action.payload,"action.payload")
      state.singleCantines=action.payload
    },
    updateCantine: (state, action) => {
      const index = state.cantines.findIndex(cantine => cantine.id === action.payload.id);
      if (index !== -1) {
        state.cantines[index] = action.payload;
      }
    },
    removeCantine: (state, action) => {
      console.log("Removing ID:", action.payload);
      state.cantines = state.cantines.filter(
        (cantine) => cantine.id !== action.payload
      );
    },    
    setProductionTypes: (state, action) => {
      state.productionTypes = action.payload;
    },
    duplicateCantine: (state, action) => {
      state.cantines.push(action.payload);
    },
    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Export actions
export const {
  setCantines,
  addCantine,
  updateCantine,
  removeCantine,
  setProductionTypes,
  duplicateCantine,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  addCantineId
} = cantineSlice.actions;

// Export selectors
export const selectCantines = (state) => state.cantine.cantines;
export const selectProductionTypes = (state) => state.cantine.productionTypes;
export const selectIsLoading = (state) => state.cantine.isLoading;
export const selectError = (state) => state.cantine.error;

// Export reducer
export default cantineSlice.reducer;